import { BiSearch } from "react-icons/bi";
import { listaEstadosActivoBusqueda } from "../../../app/constants/constants-selectores";

// Props presentacionales; la lógica (form, estado, API) vive en UsuariosPage.
// react-hook-form (register/watch/handleSubmit) y handlers se tipan laxo.
interface UsuariosFiltrosProps {
    register: any;
    watch: any;
    listaCompanias: any[];
    listaSucursales: any[];
    listaSedes: any[];
    obtenerSucursalesPorCompania: (...args: any[]) => any;
    obtenerSedesPorSucursal: (...args: any[]) => any;
    handleSubmit: any;
    onSubmitBuscar: (...args: any[]) => any;
    isMobile: boolean;
    // Mientras cargan los catálogos iniciales, los selects se muestran deshabilitados
    // con "Cargando…" para que se note que la data está llegando (no que falló).
    isLoadingFiltros?: boolean;
    // "TODOS" en Sucursal: usuarios de todas las sucursales de la compañía (solo MASTER).
    mostrarOpcionTodos?: boolean;
}

// DT1 (refactor por tamaño): campos de búsqueda de la página Usuarios.
// El <form> y handleSubmit permanecen en UsuariosPage; aquí sólo el JSX.
export const UsuariosFiltros = ({
    register,
    watch,
    listaCompanias,
    listaSucursales,
    listaSedes,
    obtenerSucursalesPorCompania,
    obtenerSedesPorSucursal,
    handleSubmit,
    onSubmitBuscar,
    isMobile,
    isLoadingFiltros = false,
    mostrarOpcionTodos = false,
}: UsuariosFiltrosProps) => {
    return (
        <>
            {/* <div className="col-12 col-lg-2">
                <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Usuario</label>
                <input
                  {...register("UseCod")}
                  type="text"
                  className="form-control form-control-sm"
                  autoComplete="off"
                  placeholder="Usuario"
                />
              </div> */}
            <div className="col-12 col-lg-2">
                <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Compañía</label>
                <select
                    {...register("compania", {
                        onChange: async (e) => {
                            await obtenerSucursalesPorCompania(e.target.value)
                            await obtenerSedesPorSucursal(watch("sucursal"))
                        },
                        required: true
                    })}
                    className="form-select form-select-sm" value={watch("compania")} disabled={isLoadingFiltros}>

                    {
                        isLoadingFiltros
                            ? <option>Cargando…</option>
                            : listaCompanias?.length > 0 && listaCompanias.map(e => (
                                <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                            ))
                    }
                </select>
            </div>
            <div className="col-12 col-lg-2">
                <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Sucursal</label>
                <select
                    {...register("sucursal", {
                        onChange: async (e) => { await obtenerSedesPorSucursal(e.target.value) },
                        required: true
                    })}
                    className="form-select form-select-sm"
                    value={watch("sucursal")}
                    disabled={isLoadingFiltros}
                >

                    {!isLoadingFiltros && mostrarOpcionTodos && <option value="T">TODOS</option>}
                    {
                        isLoadingFiltros
                            ? <option>Cargando…</option>
                            : listaSucursales?.length > 0 && listaSucursales.map(e => (

                                <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                            ))
                    }
                </select>
            </div>
            <div className="col-12 col-lg-3">
                <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Sede</label>
                <select
                    {...register("Sede", {
                        required: true
                    })}
                    className="form-select form-select-sm"
                    value={watch("Sede")}
                    disabled={isLoadingFiltros}
                >
                    {isLoadingFiltros
                        ? <option>Cargando…</option>
                        : <>
                            <option value="T">TODOS</option>
                            {
                                listaSedes?.length > 0 && listaSedes.map(e => (
                                    <option key={e?.SedCod} value={e?.SedCod}>{e?.SedDesc}</option>
                                ))
                            }
                        </>
                    }

                </select>
            </div>
            <div className="col-12 col-lg-2">
                <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Nombres</label>
                <input
                    {...register("NombreCompleto")}
                    type="text"
                    className="form-control form-control-sm"
                    autoComplete="off"
                    placeholder="Nombres"
                />
            </div>


            <div className="col-12 col-lg-2">
                <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Estado</label>
                <select {...register("Estado")} className="form-select form-select-sm">
                    {
                        listaEstadosActivoBusqueda?.length > 0 && listaEstadosActivoBusqueda.map(e => (
                            <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                        ))
                    }
                </select>
            </div>

            <div className="col-12 col-lg-1">
                <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">&nbsp;</label>
                <div className={isMobile ? "text-center" : ""}>
                    <button type="submit" onClick={handleSubmit(onSubmitBuscar)} style={{ cursor: 'pointer', background: 'none', border: 'none' }}>
                        <BiSearch size={25} className="color-iconos" />
                    </button>
                </div>
            </div>
        </>
    )
}
